/**
 * @file paddle 开发者社区数据
 * @author WanZhongun(fengguang01@baidu.com)
 */

import { useState } from 'react';
import { useMount } from 'react-use';
import { fetGetchCommunityInfo } from '../../api/pages/PaddleCommunityApi';
import {
    IPreviewData,
    IJoinCommunity,
    IGetHelp,
    IActivityCalendar,
    ICommunityResources,
    IOpenSourcePartners,
    IOpenSourceorganization,
    IOpenSourcefoundation,
    ICommunityGovernanceCommittee,
} from './types';

const usePaddleCom = () => {
    const [topCard, setTopCard] = useState<IPreviewData>({description: '', list: [], name: ''});
    const [getHelp, setGetHelp] = useState<IGetHelp>({description: '', list: [], name: '', title: ''});
    const [communityResources, setCommunityResources] = useState<ICommunityResources>({
        description: '',
        list: [],
        name: '',
        title: '',
        backgroundLink: '',
        backgroundImageUrl: ''
    });
    const [openSourcePartners, setOpenSourcePartners] = useState<IOpenSourcePartners>({
        description: '',
        list: [],
        name: '',
        title: '',
        backgroundImageUrl: '',
        subtitle: '',
        subDesc: '',
        subDescPurpose: '',
        subBtn: '',
        subLink: ''
    });
    const [joinCommunity, setJoinCommunity] = useState<IJoinCommunity>({
        description: '',
        name: '',
        openSourceCollaborationList: [],
        openSourceCollaborationTitle: '',
        organizationSummitList: [],
        organizationSummitListTitle: '',
        subtitle: '',
        title: ''
    });
    const [activityCalendar, setActivityCalendar] = useState<IActivityCalendar>({
        description: '',
        linkAllLink: '',
        list: [],
        name: '',
        title: ''
    });
    const [communityGovernanceCommittee, setCommunityGovernanceCommittee] = useState<ICommunityGovernanceCommittee>({
        avatarList: [],
        btn: '',
        btnLink: '',
        description: '',
        name: '',
        subtitle: '',
        title: '',
        backgroundLink: '',
        backgroundImageUrl: ''
    });
    const [openSourceorganization, setOpenSourceorganization] = useState<IOpenSourceorganization>({
        list: [],   
    });
    const [openSourcefoundation, setOpenSourcefoundation] = useState<IOpenSourcefoundation>({
        list: [],   
    });
    useMount(() => {
        (async () => {
            const res = await fetGetchCommunityInfo({requestUrl: '/paddleDeveloperCommunity'})
                .catch((err) => {
                    // ignore
                });
            if (res) {
                const data = res.body.result?.pageData || {};
                console.log(data)
                data.topCard && setTopCard(data.topCard);
                data.joinCommunity && setJoinCommunity(data.joinCommunity);
                data.getHelp && setGetHelp(data.getHelp);
                data.activityCalendar && setActivityCalendar(data.activityCalendar);
                data.communityResources && setCommunityResources(data.communityResources);
                data.openSourcePartners && setOpenSourcePartners(data.openSourcePartners);
                data.openSourceOrganization && setOpenSourceorganization (data.openSourceOrganization)
                data.openSourceFoundation && setOpenSourcefoundation(data.openSourceFoundation)
                data.communityGovernanceCommittee && setCommunityGovernanceCommittee(data.communityGovernanceCommittee);
            }
        })();
    });

    return {
        topCard,
        joinCommunity,
        getHelp,
        activityCalendar,
        communityResources,
        openSourcePartners,
        openSourceorganization,
        openSourcefoundation,
        communityGovernanceCommittee
    };
};

export default usePaddleCom;